export default __webpack_public_path__ + "static/media/pieczatka1.800d5ed1.gif";